import { scenes } from "@/mocks/colors";

export default function Scenes() {
  return (
    <section id="scenes" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div>
            <p className="flex items-center gap-3 text-accent-700 text-xs tracking-display uppercase">
              <span className="font-number text-lg">04</span>
              <span className="inline-block w-8 h-px bg-accent-500" />
              应用场景
            </p>
            <h2 className="mt-4 font-serif text-foreground-950 text-2xl md:text-[32px] font-semibold">
              一档黑，在不同的材质里各有分寸
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-xs hidden md:block">选黑不止看色号，也要看光泽与底调在材质上的表现。</p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {scenes.map((s) => (
            <article key={s.title} className="rounded-lg border border-background-200 bg-background-100/60 p-5 md:p-6 hover:bg-background-50 hover:border-accent-300 transition-colors group">
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-900 text-accent-400 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <span className="font-number text-4xl text-background-200 group-hover:text-accent-200 transition-colors leading-none">{scenes.indexOf(s) + 1}</span>
              </div>
              <h3 className="mt-5 text-foreground-950 font-medium text-lg">{s.title}</h3>
              <p className="mt-1 text-accent-700 text-xs tracking-wide">{s.count}</p>
              <p className="mt-3 text-[14px] leading-7 text-foreground-600">{s.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}